import Icon from '../Icon'
import styles from './styles.module.scss'

const TipsBar = ({ text, variant, secondaryVariant, icon }) => {
  return (
    <div className={`${styles.tipsbar} ${styles['tipsbar--' + variant]}`}>
      <p className={`${styles.text}  ${styles['text--' + secondaryVariant]}`}>
        {icon && <Icon width={24} height={24} name={icon} />}
        {text}
      </p>
    </div>
  )
}

export default TipsBar
